<template>
  <div class="flex gap-x-4">
    <img
      :src="imageUrl"
      :alt="rvRVName ?? undefined"
      :width="preset.width"
      :height="preset.height"
      class="w-32 flex-none rounded-lg bg-gray-50 aspect-3/2 object-cover"
    >
    <div class="min-w-0 flex flex-col justify-between gap-y-2">
      <p class="line-clamp-2 text-sm/6 font-semibold text-gray-900">
        {{ rvRVName }}
      </p>

      <div class="flex items-center gap-x-4">
        <TRating
          v-if="rvRenterRating"
          :rating="rvRenterRating"
        />

        <UserStats
          :is-superhost="rvIsSuperHostActive"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const {
  rvMainPhotoPath,
  rvRVName,
  rvRenterRating,
  rvIsSuperHostActive,
} = useRvDetails()

const { getDynamicImage, presets } = useImage()
const preset = presets.LANDSCAPE_SM

const imageUrl = computed(() => getDynamicImage({
  path: rvMainPhotoPath.value,
  preset,
}))
</script>
